/**
 * Format number 100000 => 100 000
 * @param number
 */
export const formatNumber = (number: string | number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
